<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'printCards.bulkDownloadDialogTitle' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body pc-bulk-download-dialog">
    <p class="pc-bulk-download-dialog__desc">
      {{ 'printCards.bulkDownloadDialogDesc' | translate }}
    </p>

    <mat-form-field appearance="outline" class="pc-bulk-download-dialog__field">
      <mat-label>{{ 'printCards.pageSize' | translate }}</mat-label>
      <mat-select [formControl]="pageSizePresetControl">
        @for (preset of presets; track preset.id) {
          <mat-option [value]="preset.id">
            {{ preset.labelKey | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="pc-bulk-download-dialog__search">
      <input
        matInput
        [formControl]="searchControl"
        [placeholder]="'employee.searchPlaceholder' | translate"
        [attr.aria-label]="'employee.search' | translate"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <div class="pc-bulk-download-dialog__table-wrap">
      @if (isLoadingEmployees) {
        <app-loading></app-loading>
      } @else if (filteredEmployees.length === 0) {
        <p class="pc-bulk-download-dialog__empty">
          {{ 'branchSettings.noEmployeesFound' | translate }}
        </p>
      } @else {
        <table mat-table [dataSource]="filteredEmployees" class="pc-bulk-download-dialog__table">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="isAllSelected()"
                [indeterminate]="!isAllSelected() && selectedEmployees.length > 0"
              ></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let employee">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? toggleEmployeeSelection(employee) : null"
                [checked]="isEmployeeSelected(employee)"
              ></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef>{{ 'employee.fullName' | translate }}</th>
            <td mat-cell *matCellDef="let employee">{{ employee.fullName }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>{{ 'employee.email' | translate }}</th>
            <td mat-cell *matCellDef="let employee">{{ employee.email }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['select', 'fullName', 'email']"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['select', 'fullName', 'email']"
            (click)="toggleEmployeeSelection(row)"
          ></tr>
        </table>
      }
    </div>

    @if (selectedEmployees.length > 0) {
      <p class="pc-bulk-download-dialog__selected-count">
        {{ 'branchSettings.selectedEmployees' | translate }}: {{ selectedEmployees.length }}
      </p>
    }
  </div>

  <footer class="app-dialog__footer">
    <button type="button" mat-stroked-button (click)="onCancel()">
      {{ 'cancel' | translate }}
    </button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      (click)="onConfirm()"
      [disabled]="selectedEmployees.length === 0"
    >
      {{ 'printCards.bulkDownloadDialogConfirm' | translate }}
    </button>
  </footer>
</div>
